import { useState, useEffect } from "preact/hooks";
import { PatronData, PropField } from "../types/global";

export const usePatron = (patronId: string | undefined) => {
  const [patronData, setPatronData] = useState<
    PatronData | { fields: PropField[]; error?: string }
  >({
    fields: [],
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!patronId) {
      setLoading(false);
      return;
    }

    const fetchPatronData = async () => {
      const baseUrl = "https://api.quickshot-widgets.net";

      try {
        const response = await fetch(`${baseUrl}/fields/${patronId}`);
        const data = await response.json();
        setPatronData(data);
      } catch (error) {
        setPatronData({
          fields: [],
          error: `Failed to fetch patron data with id: ${patronId}, ${error}`,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPatronData();
  }, [patronId]);

  return { patronData, loading };
};
